/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-param-reassign */
import React, {
  useRef,
  useCallback,
  useState,
  useEffect,
  useMemo,
} from 'react';
import { Link } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import {
  addMinutes,
  format,
  parseISO,
  isBefore,
  setHours,
  differenceInMinutes,
  differenceInYears,
} from 'date-fns';
import * as Yup from 'yup';

import { Button, Row, Col } from 'react-bootstrap';
import {
  FaSpinner,
  FaPlusCircle,
  FaTrashAlt,
  FaExclamationCircle,
  FaPrint,
  FaRegThumbsUp,
  FaRegThumbsDown,
} from 'react-icons/fa';
import { GiPartyPopper } from 'react-icons/gi';

import getValidationErrors from '../../utils/getValidationErrors';

import { useToast } from '../../hooks/toast';
import { useClinica } from '../../hooks/clinica';
import { useAgendamento, IProcedimentosRetorno } from '../../hooks/agendamento';

import SelectSync from '../SelectSync';
import Input from '../Input';
import InputFake from '../InputFake';
import Select from '../Select';

import TextArea from '../TextArea';
import OrcamentoProcedimento from '../OrcamentoProcedimento';
import PacienteCabecalho from '../PacienteCabecalho';
// import PacienteCadastro from '../PacienteCadastro';
import Modal from '../Modal';
import TransferirAgendamento from '../TransferirAgendamento';

import AgendamentosPaciente from './AgendamentosPaciente';

import {
  formatPrice,
  optionsHorasAtendimento,
  optionsStatusAgendamento,
  STATUS_AGENDA,
  TIPO_PERFIL,
  CONFIRMACAO_AGENDA,
  validarCPF,
  ORIGEM_AGENDAMENTO,
} from '../../utils/funcoes';

import { Container, PermissaoAdmin, Spinner } from './styles';
import api from '../../services/api';

import getResponseErrors from '../../utils/getResponseErrors';

import { IOptions } from '../../utils/options';

import { useAuth } from '../../hooks/auth';
import BuscaPaciente from '../BuscaPaciente';
import Loading from '../Loading';
import TransferirPacienteAgendamento from '../TransferirPacienteAgendamento';

import CopiarAreaTrabalho from '../CopiarAreaTrabalho';
import { usePerfil } from '../../hooks/perfil';

export interface IAgendamentoListagem {
  AgeCodigo: number;
  AgeObs: string;
  AgeInicio: Date;
  AgeFim: Date;
  AgeStatus: number;
  AgeConfirmado: number;
  AgePlano: boolean;
  paciente: {
    PacCodigo: number;
    PacNome: string;
    PacNomeSocial: string;
  };
  top?: number;
  left?: string;
  width?: string;
  height?: string;
  status?: {
    id: number;
    nome: string;
    color: string;
    icon: string;
  };
}

type AgendamentoProps = {
  AgeCodigo?: number;
  agendaId?: number;
  perfilId?: string;
  data?: Date;
  handleFecharAgendamento(
    agendamentoListagem: IAgendamentoListagem | undefined,
  ): void;
};

export interface IRetornoStatusParcelaCartaoDTO {
  PlaCodigo: number;
  Status: string;
  Parcelas: number;
}
export interface IPaciente {
  PacCodigo: number;
  PacNome: string;
  PacNomeSocial: string;
  PacDataNasc: string;
  PacIdade: string;
  PacDataNascFormatada: string;
  PacCPF: string;
  PacRG: string;
  PacTelefone: string;
  PacCelular: string;
  PacEmail: string;
  PacDataCadastro: Date;
  PacSexo: string;
  PacResponsavel: string;
  PacResponsavelCPF: string;
  PacResponsavelRG: string;
  PacAtivo: boolean;
  PacRestrito: boolean;
  avatar_url: string;
}

interface IPacienteDadosObrigatorios {
  dadosValidos: boolean;
  msg: string;
}

export interface IAgendamentosPaciente {
  AgeCodigo: number;
  AgeInicio: Date;
  AgeFim: Date;
  AgeStatus: number;
  AgeConfirmado: number;
  AgeConvCodigo: number;
  ConNome: string;
  AgeMedUsuCodigo?: number;
  AgeObs?: string;
  ConAtende?: boolean;
  configuracaoAgenda?: {
    ConAtende: number;
    ConNome: string;
  };
}

export interface IPacienteMaisCartaoDTO extends IPaciente {
  possuiCartao: boolean;
  cartao: IRetornoStatusParcelaCartaoDTO[];
  agendamentosPaciente: IAgendamentosPaciente[];
  atendimentos: number;
  faltas: number;
}

interface IHistorico {
  HisCodigo: number;
  HisLog: string;
  HisData: Date;
  HisDataFormatada: string;
}

export interface IAgendamento {
  AgeConfCodigo: number;
  AgeMedUsuCodigo?: number;
  AgeAteUsuCodigo: number;
  AgeAteUsuClinica: number;
  AgePacCodigo: number;
  AgeTipo: number;
  AgeTratamento: number;
  AgeCheckup: number;
  AgeObs: string;
  AgeChave: string;
  AgeInicio: Date;
  AgeFim: Date;
  AgeStatus: number;
  AgeConfirmado?: number;
  AgeFormaPag: number;
  AgeDataLiberacao?: Date;
  AgeEmail?: Date;
  AgePlano: boolean;
  AgeTelemedicina: boolean;
  AgeClinica: number;
  AgeOrigem: number;
  AgeGuia: string;
  AgeConvCodigo: string;
  updated_at: Date;
  procedimentos: [
    {
      ProNome: string;
      ProCodigo: number;
      ProPerCodigo: number;
      ProValor: number;
      ProValorPlano: number;
      ProValorPlano2: number;
      ProValorCobrado: number;
      ProDuracao: number;
      ProCodigoAlvaro?: string;
      perfil: {
        PerCodigo: number;
        PerNome: string;
        PerTipo: Number;
        PerAtivo: boolean;
      };
    },
  ];
  paciente: IPaciente;
  possuiCartao: boolean;
  cartao: IRetornoStatusParcelaCartaoDTO[];
  agendamentos: IAgendamentosPaciente[];
  atendimentos: number;
  faltas: number;
}

export interface ProfileFormDados {
  pacienteID: string;
}

interface AgendamentoFormDados {
  AgeData: Date;
  AgeHora: string;
  AgeStatus: string;
  AgeConvCodigo: string;
  AgeConfirmado?: string;
  AgeObs: string;
  AgeGuia: string;
  duracaoTotal: string;
  login?: string;
  senha?: string;
}

export interface IProcedimento {
  ProCodigo: number;
  ProCodigoAlvaro: string;
  ProNome: string;
  ProDuracao: number;
  ProValor: number;
  ProValorPlano: number;
  ProValorPlano2: number;
  ProValorFormatado: string;
  ProValorPlanoFormatado: string;
  ProValorPlano2Formatado: string;
  ProCarencia: number;
  ProLimite: number;
}

export interface IProcedimentoAgendamento {
  ProCodigo: number;
  ProNome: string;
  ProValor: number;
  ProValorFormatado: string;
  ProDuracao: number;
}
export interface IRetornoProcedimentoAssociado {
  ProCodigo: number;
  ProValor: number;
  msg: string;
}

interface IAgendamentoAntecipadoSubmit {
  AgeCodigo?: number;
  AgeObs: string;
  AgeInicio: Date;
  AgeFim: Date;
  AgePlano?: boolean;
  AgeConfirmado: number;
  AgeGuia: string;
  AgeConvCodigo?: number;
  updated_at: Date;
  paciente?: { PacCodigo: number; PacNome: string; PacNomeSocial: string };
  permissao?: { UsuLogin?: string; UsuSenha?: string };
}

const Agendamento: React.FC<AgendamentoProps> = ({
  AgeCodigo = undefined,
  agendaId = undefined,
  perfilId = undefined,
  data,
  handleFecharAgendamento,
}) => {
  const {
    imagensClinica,
    buscaConvenios,
    optionsConvenio,
    convenios,
  } = useClinica();

  const { user, clinica } = useAuth();

  const { perfis, buscaPerfil } = usePerfil();

  const semFoto =
    imagensClinica.find(img => img.nome === 'semFoto')?.arquivo_url || '';

  const cliSaoPaulo = !!imagensClinica.find(img => img.nome === 'saopaulo');

  const [showModalOrcamento, setShowModalOrcamento] = useState(false);
  const [showModalCancelar, setShowModalCancelar] = useState(false);

  const [showModalTransferirAgenda, setShowModalTransferirAgenda] = useState(
    false,
  );
  const [
    showModalTransferirPaciente,
    setShowModalTransferirPaciente,
  ] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingProcedimento, setLoadingProcedimento] = useState(false);
  const [agendamentoBloqueado, setAgendamentoBloqueado] = useState(false);
  const [bloqueiaDiaPassado, setBloqueiaDiaPassado] = useState(false);
  const [bloqueiaDadosInclompletos, setBloqueiaDadosInclompletos] = useState(
    false,
  );
  const [exibePermissaoAdmin, setExibePermissaoAdmin] = useState(false);
  const [mensagemPermissaoAdmin, setMensagemPermissaoAdmin] = useState('');
  const formRefAgendamento = useRef<FormHandles>(null);

  const [pacienteID, setPacienteID] = useState<number | undefined>();
  const [paciente, setPaciente] = useState<IPaciente>();
  const [
    pacienteDadosObrigatorios,
    setPacienteDadosObrigatorios,
  ] = useState<IPacienteDadosObrigatorios>();
  const [dadosPlano, setDadosPlano] = useState<
    IRetornoStatusParcelaCartaoDTO | undefined
  >();
  const [agePlano, setAgePlano] = useState(false);
  const [cartaoEmDia, setCartaoEmDia] = useState(false);
  const [ageStatus, setAgeStatus] = useState(STATUS_AGENDA.AGENDADO);
  const [ageTratamento, setAgeTratamento] = useState(0);
  const [ageCheckup, setAgeCheckup] = useState(0);

  const [ageConfirmado, setAgeConfirmado] = useState(
    CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO,
  );

  const [agendamentoDados, setAgendamentoDados] = useState<
    | {
      duracao: number;
      AgeObs: string;
      AgeChave: string;
      AgeGuia: string;
      AgeConvCodigo: string;
    }
    | undefined
  >(undefined);
  const [showHistorico, setShowHistorico] = useState(false);
  const [historico, setHistorico] = useState<IHistorico[]>([]);
  const [agendamentosPaciente, setAgendamentosPaciente] = useState<
    IAgendamentosPaciente[]
  >([]);
  const [atendimentos, setAtendimentos] = useState(0);
  const [faltas, setFaltas] = useState(0);
  const [perfil, setPerfil] = useState(perfilId);
  const [perfilNome, setPerfilNome] = useState('');
  const [procedimentos, setProcedimentos] = useState<IProcedimento[]>();
  const [
    procedimentoSelecionado,
    setProcedimentoSelecionado,
  ] = useState<IProcedimento>();
  const [procedimentosAgendamento, setProcedimentosAgendamento] = useState<
    IProcedimentoAgendamento[]
  >([]);
  const [dataSelecionada, setDataSelecionada] = useState(
    data ? parseISO(data.toString()) : new Date(),
  );
  const [updatedAt, setUpdatedAt] = useState(new Date());
  const [conCodigo, setConCodigo] = useState(agendaId);
  const [exibePedidoExame, setExibePedidoExame] = useState(false);
  // const [convenioSelecionado, setConvenioSelecionado] = useState<
  //   IConvenio | undefined
  // >();

  const [codigoConvenio, setCodigoConvenio] = useState<number | undefined>();

  const { addToast } = useToast();
  const {
    buscaProcedimentos,
    loading: loadingProcedimentosHook,
  } = useAgendamento();

  const [optionsHora, setOptionsHora] = useState(() =>
    optionsHorasAtendimento(),
  );

  const [optionsProcedimentos, setOptionsProcedimentos] = useState<IOptions[]>(
    [],
  );

  const [valorEconomizado, setValorEconomizado] = useState<string>();

  const handleVerificaDadosObrigatoriosPaciente = useCallback(
    (dados: IPaciente) => {
      if (clinica.CliValidaDadosNF) {
        // if (cliSaoPaulo) {
        let mensagem = '';
        const dataNascimento = new Date(dados.PacDataNasc.toString());
        const menorIdade = differenceInYears(new Date(), dataNascimento) < 18;
        if (!menorIdade) {
          if (!dados.PacCPF || dados.PacCPF.length !== 11) {
            mensagem = 'CPF não cadastrado';
          } else if (!validarCPF(dados.PacCPF)) mensagem = 'CPF inválido';

          // if (!dados.PacRG || dados.PacRG.length < 4)
          //   mensagem = `${mensagem} - RG não cadastrado`;
        }

        if (menorIdade) {
          if (
            !dados.PacResponsavelCPF ||
            dados.PacResponsavelCPF.length !== 11
          ) {
            mensagem = 'CPF do Responsável não cadastrado';
          } else if (!validarCPF(dados.PacResponsavelCPF))
            mensagem = 'CPF do Responsável inválido';

          // if (!dados.PacResponsavelRG || dados.PacResponsavelRG.length < 4)
          //   mensagem = `${mensagem} - RG do Responsável não cadastrado`;
        }

        if (mensagem === '') {
          setPacienteDadosObrigatorios({ dadosValidos: true, msg: '' });
          setBloqueiaDadosInclompletos(false);
        }
        if (mensagem !== '') {
          setPacienteDadosObrigatorios({ dadosValidos: false, msg: mensagem });
          setBloqueiaDadosInclompletos(true);
        }
      }
    },
    [clinica.CliValidaDadosNF],
  );

  useEffect(() => {
    async function loadPerfis(): Promise<void> {
      await buscaPerfil();
    }
    if (!perfis.perfis || perfis.perfis.length === 0) loadPerfis();
  }, [buscaPerfil, perfis]);

  useEffect(() => {
    async function Busca(): Promise<void> {
      await buscaConvenios();
    }
    if (
      clinica.CliAtendeConvenio &&
      (!optionsConvenio || optionsConvenio.length === 0)
    )
      Busca();
  }, [optionsConvenio, clinica.CliAtendeConvenio]);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IAgendamento>(
          `/agendamentos/${AgeCodigo}/detalhe`,
        );

        let cartaoEmDiaOK = false;
        if (
          response.data.possuiCartao &&
          response.data.cartao &&
          response.data.cartao.length > 0
        ) {
          cartaoEmDiaOK = response.data.cartao[0].Status === 'Em Dia';
          setDadosPlano(response.data.cartao[0]);
          setCartaoEmDia(cartaoEmDiaOK);
        }

        setConCodigo(response.data.AgeConfCodigo);
        setUpdatedAt(response.data.updated_at);
        const dataIni = parseISO(response.data.AgeInicio.toString());
        const dataFim = parseISO(response.data.AgeFim.toString());
        setAgendamentoDados({
          AgeObs: response.data.AgeObs,
          duracao: differenceInMinutes(dataFim, dataIni),
          AgeChave: response.data.AgeChave,
          AgeGuia: response.data.AgeGuia,
          AgeConvCodigo: response.data.AgeConvCodigo.toString(),
        });

        setCodigoConvenio(Number(response.data.AgeConvCodigo));

        if (response.data.AgeStatus === STATUS_AGENDA.AGENDADO) {
          setAgeStatus(
            response.data.AgeConfirmado ===
              CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO
              ? STATUS_AGENDA.AGENDADO
              : STATUS_AGENDA.AGENDADO + 1,
          );
        } else {
          setAgeStatus(response.data.AgeStatus);
        }

        setAgeConfirmado(
          response.data.AgeConfirmado ||
          CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO,
        );
        setDataSelecionada(dataIni);
        setPacienteID(response.data.AgePacCodigo);

        // verificar pq foi desativado
        setPerfil(response.data.procedimentos[0]?.ProPerCodigo?.toString());
        setPerfilNome(response.data.procedimentos[0]?.perfil?.PerNome || '');

        setAgePlano(cartaoEmDiaOK);

        setAgeTratamento(response.data.AgeTratamento);
        setAgeCheckup(response.data.AgeCheckup);

        setPaciente(response.data.paciente);

        handleVerificaDadosObrigatoriosPaciente(response.data.paciente);

        setAgendamentosPaciente(response.data.agendamentos);
        setAtendimentos(response.data.atendimentos);
        setFaltas(response.data.faltas);

        setExibePedidoExame(response.data.AgeTipo === TIPO_PERFIL.EXAME);

        if (
          response.data.AgeStatus !== STATUS_AGENDA.AGENDADO ||
          ((response.data.AgeStatus === STATUS_AGENDA.AGENDADO &&
            response.data.AgeOrigem !== ORIGEM_AGENDAMENTO.SISTEMA && response.data.AgeOrigem !== ORIGEM_AGENDAMENTO.WHATSAPP) ||
            (response.data.AgeOrigem === ORIGEM_AGENDAMENTO.WHATSAPP
              && (response.data.AgeConfirmado !== undefined && response.data.AgeConfirmado > CONFIRMACAO_AGENDA.NAO_VAI))) ||
          response.data.AgeTratamento > 0 ||
          response.data.AgeCheckup > 0
        ) {
          setAgendamentoBloqueado(true);
        } else {
          const responsePerfis = await api.get<number[]>(
            `/agendas/${response.data.AgeConfCodigo}/perfis`,
          );

          if (!perfilId) setPerfil(responsePerfis.data.join(','));
          const respostaPro = await buscaProcedimentos(
            responsePerfis.data.join(','),
            response.data.AgeConvCodigo,
          );

          if (respostaPro) {
            setProcedimentos(respostaPro.procedimentos);
            setOptionsProcedimentos(respostaPro.optionsProcedimento);
          }
        }

        setProcedimentosAgendamento(
          response.data.procedimentos.map(pro => {
            return {
              ProCodigo: pro.ProCodigo,
              ProNome: pro.ProNome,
              ProValor: pro.ProValorCobrado,
              ProValorFormatado: formatPrice(pro.ProValorCobrado),
              ProDuracao: pro.ProDuracao,
            };
          }),
        );
      } catch (error) {
        console.log(error);
        addToast({
          title: 'Não foi possível buscar o agendamento',
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
    }
    if (AgeCodigo && AgeCodigo !== 0) loadDados();
  }, [
    AgeCodigo,
    addToast,
    buscaProcedimentos,
    handleVerificaDadosObrigatoriosPaciente,
    semFoto,
    perfilId,
  ]);

  useEffect(() => {
    async function busca(): Promise<void> {
      const resposta = await buscaProcedimentos(perfil || '0');

      if (resposta) {
        setProcedimentos(resposta.procedimentos);
        setOptionsProcedimentos(resposta.optionsProcedimento);
      }
    }
    if (perfil && perfil.length !== 0 && (!AgeCodigo || AgeCodigo === 0))
      busca();
  }, [perfil, AgeCodigo, buscaProcedimentos]);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      try {
        setLoading(true);
        const response = await api.get<IPacienteMaisCartaoDTO>(
          `/pacientes/pacientemaiscartao/${pacienteID}`,
        );

        setPaciente(response.data);

        setAgendamentoDados({
          AgeObs: '',
          duracao: 0,
          AgeGuia: '',
          AgeConvCodigo: '',
          AgeChave: '',
        });

        handleVerificaDadosObrigatoriosPaciente(response.data);

        setAgendamentosPaciente(response.data.agendamentosPaciente);
        setAtendimentos(response.data.atendimentos);
        setFaltas(response.data.faltas);

        if (response.data.possuiCartao && response.data.cartao) {
          setDadosPlano(response.data.cartao[0]);
          setCartaoEmDia(response.data.cartao[0].Status === 'Em Dia');
          setAgePlano(response.data.cartao[0].Status === 'Em Dia');
        }
      } catch (error) {
        addToast({
          title: 'Não foi possível buscar o paciente',
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
    }
    if (pacienteID && !AgeCodigo) loadDados();
  }, [
    pacienteID,
    AgeCodigo,
    addToast,
    handleVerificaDadosObrigatoriosPaciente,
    semFoto,
  ]);

  useEffect(() => {
    if (
      agePlano &&
      cliSaoPaulo &&
      procedimentosAgendamento &&
      procedimentosAgendamento.length > 0 &&
      procedimentos &&
      procedimentos.length > 0
    ) {
      const valorCobrado = procedimentosAgendamento.reduce((tot, prod) => {
        return tot + Number(prod.ProValor);
      }, 0);

      let valorCheio = 0;
      procedimentosAgendamento.forEach(pro => {
        const procedimentoBanco = procedimentos.find(
          proc => proc.ProCodigo === pro.ProCodigo,
        );
        if (procedimentoBanco) valorCheio += procedimentoBanco.ProValor;
      });
      setValorEconomizado(formatPrice(valorCheio - valorCobrado));
    } else {
      setValorEconomizado(undefined);
    }
  }, [agePlano, cliSaoPaulo, procedimentos, procedimentosAgendamento]);

  const handleSelectClienteChange = useCallback(
    ({ value, label }: { value: string; label: string }) => {
      if (value) {
        setPacienteID(Number(value));
      }
    },
    [],
  );

  const handleProcedimentoChange = useCallback(
    ({ value, label }) => {
      // const ProCodigo = formRefAgendamento.current?.getFieldValue('procedimento');
      if (value) {
        const procedimento = procedimentos?.find(
          proced => proced.ProCodigo === Number(value),
        );
        setProcedimentoSelecionado(procedimento);
      } else {
        setProcedimentoSelecionado(undefined);
      }
    },
    [procedimentos],
  );

  const total = useMemo(() => {
    const valor = procedimentosAgendamento.reduce((tot, prod) => {
      return tot + Number(prod.ProValor);
    }, 0);
    return {
      duracao: procedimentosAgendamento.reduce((tot, prod) => {
        return tot + Number(prod.ProDuracao);
      }, 0),
      valor,
      valorFormatado: formatPrice(valor),
    };
  }, [procedimentosAgendamento]);

  const temProcedimentos = useMemo(() => {
    return !!(procedimentosAgendamento && procedimentosAgendamento.length > 0);
  }, [procedimentosAgendamento]);

  const handleAddProcedimento = useCallback(async () => {
    if (!procedimentoSelecionado) {
      return;
    }
    let valorCobrado =
      agePlano && cartaoEmDia
        ? procedimentoSelecionado.ProValorPlano
        : procedimentoSelecionado.ProValor;
    if (agePlano && !codigoConvenio) {
      // verifica se agendamento ta ok com valor
      setLoadingProcedimento(true);
      try {
        const dataformatada = format(dataSelecionada, 'yyyy-MM-dd');
        const response = await api.get<IRetornoProcedimentoAssociado[]>(
          `agendamentos/validaprocedimento?ProCodigo=${procedimentoSelecionado?.ProCodigo}&ProNome=${procedimentoSelecionado?.ProNome}&ProValor=${valorCobrado}&PacCodigo=${pacienteID}&AgeData=${dataformatada}`,
        );

        if (response.data.length !== 0) {
          valorCobrado = response.data[0].ProValor;
          addToast({
            type: 'info',
            title: 'Valor alterado pelo sistema',
            description: response.data[0].msg,
          });
        }
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Erro ao buscar dados, tente novamente',
        });
        valorCobrado = -1;
      } finally {
        setLoadingProcedimento(false);
      }
      if (valorCobrado === -1) {
        return;
      }
    }

    const duracaoTotal = total.duracao + procedimentoSelecionado.ProDuracao;
    if (formRefAgendamento && formRefAgendamento.current) {
      formRefAgendamento.current.setFieldValue(
        'duracaoTotal',
        duracaoTotal.toString(),
      );
    }
    setProcedimentosAgendamento(state => [
      ...state,
      {
        ProCodigo: procedimentoSelecionado.ProCodigo,
        ProNome: procedimentoSelecionado.ProNome,
        ProValor: valorCobrado,
        ProValorFormatado: formatPrice(valorCobrado),
        ProDuracao: procedimentoSelecionado.ProDuracao,
      },
    ]);
    setProcedimentoSelecionado(undefined);
  }, [
    procedimentoSelecionado,
    agePlano,
    cartaoEmDia,
    dataSelecionada,
    pacienteID,
    total.duracao,
    codigoConvenio,
    addToast,
  ]);

  const handleRemoveProcedimento = useCallback((ProCodigo: Number) => {
    setProcedimentosAgendamento(state =>
      state.filter(pro => pro.ProCodigo !== ProCodigo),
    );
  }, []);

  const handleSubmitMudaStatus = useCallback((status: number) => {
    if (formRefAgendamento && formRefAgendamento.current) {
      formRefAgendamento.current.setFieldValue('AgeStatus', status.toString());
      formRefAgendamento.current.submitForm();
    }
  }, []);

  const dataHoraInitialDataForm = useMemo(() => {
    return {
      AgeData: format(dataSelecionada, 'yyyy-MM-dd'),
      AgeHora: format(dataSelecionada, 'HH:mm'),
      AgeStatus: ageStatus.toString(),
    };
  }, [dataSelecionada, ageStatus]);

  const handleAlteraDataAntecipado = useCallback(
    async (dados: IAgendamentoAntecipadoSubmit) => {
      try {
        const codigo = dados.AgeCodigo;
        const pacient = dados.paciente;
        delete dados.AgeCodigo;
        delete dados.AgePlano;
        delete dados.paciente;
        delete dados.AgeConvCodigo;
        const response = await api.put(
          `/agendamentoantecipado/${codigo}/alteradata`,
          dados,
        );
        handleFecharAgendamento({
          ...response.data,
          paciente: pacient || { PacCodigo: 0, PacNome: '' },
        });
      } catch (error: any) {
        const mensagemErro = getResponseErrors(error);
        const statusErro = error?.response?.status;
        if (statusErro === 403) {
          setExibePermissaoAdmin(true);
          setMensagemPermissaoAdmin(mensagemErro);
        }
        addToast({
          type: 'error',
          title: 'Erro ao salvar agendamento',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, handleFecharAgendamento],
  );

  const handleEncaminhaAntecipado = useCallback(async () => {
    try {
      setLoading(true);
      if (!AgeCodigo) throw new Error('Nenhuma agenda selecionada.');
      const response = await api.put(
        `/agendamentoantecipado/${AgeCodigo}/encaminhar`,
      );
      handleFecharAgendamento({
        ...response.data,
        paciente: paciente || { PacCodigo: 0, PacNome: '' },
      });
    } catch (error: any) {
      const mensagemErro = getResponseErrors(error);
      const statusErro = error?.response?.status;
      if (statusErro === 403) {
        setExibePermissaoAdmin(true);
        setMensagemPermissaoAdmin(mensagemErro);
      }
      addToast({
        type: 'error',
        title: 'Erro ao salvar agendamento',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, handleFecharAgendamento, AgeCodigo, paciente]);

  const handleSalvarObservacao = useCallback(async () => {
    try {
      setLoading(true);
      if (!AgeCodigo) throw new Error('Nenhuma agenda selecionada.');
      const AgeObs = formRefAgendamento.current?.getFieldValue('AgeObs');
      const response = await api.put(`/agendamentos/observacao/${AgeCodigo}`, {
        AgeObs,
        updated_at: updatedAt,
      });
      handleFecharAgendamento({
        ...response.data,
        paciente: paciente || { PacCodigo: 0, PacNome: '' },
      });
    } catch (error: any) {
      const mensagemErro = getResponseErrors(error);
      const statusErro = error?.response?.status;
      if (statusErro === 403) {
        setExibePermissaoAdmin(true);
        setMensagemPermissaoAdmin(mensagemErro);
      }
      addToast({
        type: 'error',
        title: 'Erro ao salvar agendamento',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, handleFecharAgendamento, AgeCodigo, paciente, updatedAt]);

  const handleConfirmarAgenda = useCallback(
    async (confirmado: number) => {
      try {
        setLoading(true);
        if (!AgeCodigo) throw new Error('Nenhuma agenda selecionada.');
        const response = await api.put(`/agendamentos/confirmar/${AgeCodigo}`, {
          updated_at: updatedAt,
          AgeConfirmado: confirmado,
        });
        handleFecharAgendamento({
          ...response.data,
          paciente: paciente || { PacCodigo: 0, PacNome: '' },
        });
      } catch (error: any) {
        const mensagemErro = getResponseErrors(error);
        const statusErro = error?.response?.status;
        if (statusErro === 403) {
          setExibePermissaoAdmin(true);
          setMensagemPermissaoAdmin(mensagemErro);
        }
        addToast({
          type: 'error',
          title: 'Erro ao salvar agendamento',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, handleFecharAgendamento, AgeCodigo, paciente, updatedAt],
  );

  const handleSubmitAgendamento = useCallback(
    async (dados: AgendamentoFormDados) => {
      setLoading(true);
      try {
        formRefAgendamento.current?.setErrors({});

        const schema = Yup.object().shape({
          AgeData: Yup.date().required(),
          AgeHora: Yup.string().required('E-mail obrigatório'),
          duracaoTotal: Yup.number().required(),
          AgeObs: Yup.string(),
          ...(exibePermissaoAdmin
            ? {
              login: Yup.string().required('Login é obrigatório'),
              senha: Yup.string().required('Senha é obrigatória'),
            }
            : {}),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        const dataAgendamento = parseISO(
          `${dados.AgeData} ${dados.AgeHora}:00`,
        );

        const novoAgendamento = !AgeCodigo || AgeCodigo === 0;

        if (Number(dados.AgeStatus) === STATUS_AGENDA.PAGAMENTO_ANTECIPADO) {
          // passar os parametros aqui
          handleAlteraDataAntecipado({
            AgeCodigo: AgeCodigo || 0,
            AgeObs: dados.AgeObs,
            AgeInicio: dataAgendamento,
            AgeFim: addMinutes(dataAgendamento, Number(dados.duracaoTotal)),
            ...(exibePermissaoAdmin
              ? { permissao: { UsuLogin: dados.login, UsuSenha: dados.senha } }
              : {}),
            updated_at: updatedAt,
            AgePlano: agePlano,
            AgeConfirmado: ageConfirmado,
            AgeGuia: dados.AgeGuia,
            AgeConvCodigo: Number(dados.AgeConvCodigo),
            paciente: {
              PacCodigo: pacienteID || 0,
              PacNome: paciente?.PacNome || '',
              PacNomeSocial: paciente?.PacNomeSocial || '',
            },
          });
          return;
        }

        if (
          !procedimentosAgendamento ||
          procedimentosAgendamento.length === 0
        ) {
          addToast({ title: 'Adicione procedimentos', type: 'error' });
          return;
        }

        if (
          dados.AgeConvCodigo !== '' &&
          Number(dados.AgeConvCodigo) > 0 &&
          Number(dados.AgeStatus) === STATUS_AGENDA.ENCAMINHADO_CAIXA
        ) {
          if (dados.AgeGuia === '') {
            addToast({
              type: 'error',
              title: 'Erro ao encaminhar agendamento',
              description: 'Número da Guia obrigatório quando Convênio.',
            });
            return;
          }
        }

        const agendamento = {
          ...(novoAgendamento
            ? {
              AgeConfCodigo: conCodigo,
              AgePacCodigo: pacienteID,
              AgeFormaPag: 9,
            }
            : { updated_at: updatedAt }),
          AgeObs: dados.AgeObs.toUpperCase(),
          AgeInicio: dataAgendamento,
          AgeFim: addMinutes(dataAgendamento, Number(dados.duracaoTotal)),
          AgeStatus:
            Number(dados.AgeStatus) === STATUS_AGENDA.AGENDADO ||
              Number(dados.AgeStatus) === STATUS_AGENDA.AGENDADO + 1
              ? STATUS_AGENDA.AGENDADO
              : Number(dados.AgeStatus),
          AgeConfirmado: ageConfirmado,
          AgePlano: agePlano,
          AgeGuia: dados.AgeGuia.toUpperCase(),
          AgeConvCodigo: Number(dados.AgeConvCodigo),
          duracao: dados.duracaoTotal,
          procedimentos: procedimentosAgendamento.map(pro => {
            return {
              ProCodigo: pro.ProCodigo,
              ProNome: pro.ProNome,
              ProValor: pro.ProValor,
            };
          }),
          ...(exibePermissaoAdmin
            ? { permissao: { UsuLogin: dados.login, UsuSenha: dados.senha } }
            : {}),
        };

        if (novoAgendamento) {
          const agendamentoSalvao = await api.post(
            '/agendamentos',
            agendamento,
          );

          addToast({ title: 'Agendamento salvo', type: 'success' });
          handleFecharAgendamento({
            ...agendamentoSalvao.data,
            paciente: {
              PacCodigo: pacienteID,
              PacNome: paciente?.PacNome,
              PacNomeSocial: paciente?.PacNomeSocial,
            },
          });
        } else {
          const agendamentoAtualizado = await api.put(
            `/agendamentos/${AgeCodigo}`,
            agendamento,
          );

          addToast({ title: 'Agendamento atualizado', type: 'success' });
          handleFecharAgendamento({
            ...agendamentoAtualizado.data,
            paciente: {
              PacCodigo: pacienteID,
              PacNome: paciente?.PacNome,
              PacNomeSocial: paciente?.PacNomeSocial,
            },
          });
        }
      } catch (error: any) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRefAgendamento.current?.setErrors(errors);
          return;
        }
        const mensagemErro = getResponseErrors(error);
        const statusErro = error?.response?.status;
        if (statusErro === 403) {
          setExibePermissaoAdmin(true);
          setMensagemPermissaoAdmin(mensagemErro);
        }
        addToast({
          type: 'error',
          title: 'Erro ao salvar agendamento',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      exibePermissaoAdmin,
      procedimentosAgendamento,
      pacienteID,
      paciente?.PacNome,
      paciente?.PacNomeSocial,
      agePlano,
      updatedAt,
      conCodigo,
      AgeCodigo,
      addToast,
      handleFecharAgendamento,
      handleAlteraDataAntecipado,
      ageConfirmado,
    ],
  );

  const exibeAgendamento = useMemo(() => {
    return !!(pacienteID && conCodigo && paciente);
  }, [pacienteID, conCodigo, paciente]);

  const handleAlteraData = useCallback(() => {
    if (formRefAgendamento && formRefAgendamento.current) {
      const dataString = String(
        formRefAgendamento.current.getFieldValue('AgeData'),
      );

      if (dataString.length !== 10) {
        return;
      }

      const dataConvertida = parseISO(dataString);

      setDataSelecionada(dataConvertida);
    }
  }, []);

  useEffect(() => {
    setBloqueiaDiaPassado(isBefore(setHours(dataSelecionada, 23), new Date()));
  }, [dataSelecionada]);

  useEffect(() => {
    if (ageConfirmado > CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO)
      formRefAgendamento.current?.submitForm();
  }, [ageConfirmado]);

  useEffect(() => {
    setOptionsProcedimentos(state =>
      state.map(opt => {
        return {
          ...opt,
          isDisabled: !!procedimentosAgendamento.find(
            pro => pro.ProCodigo === Number(opt.value),
          ),
        };
      }),
    );
  }, [procedimentosAgendamento]);

  const handleCancelaAgendamento = useCallback(
    async (falta: boolean) => {
      setLoading(true);
      try {
        if (!AgeCodigo || AgeCodigo === 0) {
          addToast({
            title: 'Agendamento inválido',
            type: 'error',
          });
          return;
        }

        await api.delete(
          `/agendamentos/${AgeCodigo}?updated_at=${updatedAt}${falta ? '&adicionaFalta=true' : ''
          }`,
        );
        handleFecharAgendamento({
          AgeCodigo,
          AgeInicio: new Date(),
          AgeFim: new Date(),
          AgeObs: '',
          AgePlano: false,
          AgeStatus: falta ? STATUS_AGENDA.FALTA : STATUS_AGENDA.CANCELADO,
          AgeConfirmado: ageConfirmado,
          paciente: { PacCodigo: 0, PacNome: 'teste', PacNomeSocial: '' },
        });
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível cancelar o agendamento',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [AgeCodigo, updatedAt, addToast, handleFecharAgendamento, ageConfirmado],
  );

  const handleBuscaHistorico = useCallback(async () => {
    setLoading(true);
    try {
      if (!AgeCodigo || AgeCodigo === 0) {
        addToast({
          title: 'Agendamento inválido',
          type: 'error',
        });
        return;
      }

      const response = await api.get<IHistorico[]>(
        `/agendamentos/historico/${AgeCodigo}`,
      );

      setHistorico(
        response.data.map(his => {
          return {
            ...his,
            HisDataFormatada: format(
              parseISO(his.HisData.toString()),
              'dd/MM/yyyy HH:mm:ss',
            ),
          };
        }),
      );
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível buscar o histórico',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [AgeCodigo, addToast]);

  const handleExibeHistorico = useCallback(
    historicoEstaVisivel => {
      if (historicoEstaVisivel) setShowHistorico(false);
      if (!historicoEstaVisivel) {
        if (historico.length === 0) handleBuscaHistorico();

        setShowHistorico(true);
      }
    },
    [handleBuscaHistorico, historico.length],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  const handleCadastrouPaciente = useCallback((PacCodigo: number) => {
    setPacienteID(PacCodigo);
  }, []);

  const handleTransferiuAgenda = useCallback(
    (agendamento: IAgendamentoListagem) => {
      setShowModalTransferirAgenda(false);
      handleFecharAgendamento({
        ...agendamento,
        paciente: { PacCodigo: 0, PacNome: '', PacNomeSocial: '' },
      });
    },
    [],
  );

  const handleOnChangeConvenio = useCallback(
    async option => {
      setCodigoConvenio(
        option && option.value ? Number(option.value) : undefined,
      );

      setProcedimentoSelecionado(undefined);
      let resposta: IProcedimentosRetorno | undefined;

      formRefAgendamento.current?.setFieldValue('AgeConvCodigo', '0');

      if (option && option.value) {
        const convenio = convenios.find(
          con => con.ConvCodigo === Number(option.value),
        );
        // setConvenioSelecionado(convenio);
        // console.log(convenio);
        if (convenio && AgeCodigo && convenio.ConvGeraGuia)
          formRefAgendamento.current?.setFieldValue('AgeGuia', AgeCodigo);
      }
      // else {
      //   setConvenioSelecionado(undefined);
      // }

      if (option && option.value && perfil) {
        resposta = await buscaProcedimentos(perfil, option.value);
      } else {
        resposta = await buscaProcedimentos(perfil || '0');
      }

      if (resposta) {
        const proceds = resposta.procedimentos.map(procedimento => {
          return {
            ...procedimento,
            ProValorFormatado: formatPrice(procedimento.ProValor),
            ProValorPlanoFormatado: formatPrice(procedimento.ProValorPlano),
            ProValorPlano2Formatado: formatPrice(procedimento.ProValorPlano2),
          };
        });

        setProcedimentos(proceds);
        setOptionsProcedimentos(resposta.optionsProcedimento);

        setProcedimentosAgendamento(state => {
          const procedimentosFiltrados = state.filter(pro =>
            proceds.some(b => pro.ProCodigo === b.ProCodigo),
          );

          if (!option) return [];
          if (!procedimentosFiltrados) return [];

          const novosProcedimentos = !option
            ? []
            : procedimentosFiltrados.map(pro => {
              const procedimentoFind = proceds.find(
                proc => proc.ProCodigo === pro.ProCodigo,
              );

              let valorCobradoConvenio = {};

              if (procedimentoFind) {
                // Se convenio
                if (option && option.value) {
                  valorCobradoConvenio = {
                    ...procedimentoFind,
                    ProValor: procedimentoFind.ProValor,
                    ProValorFormatado: procedimentoFind.ProValorFormatado,
                  };
                }
              }

              return {
                ...pro,
                ...valorCobradoConvenio,
              };
            });

          if (novosProcedimentos) return novosProcedimentos;
          return [];
        });
      }
    },
    [buscaProcedimentos, perfil, AgeCodigo, convenios],
  );

  const IconeConfirmado = useCallback((confirmado: number) => {
    if (confirmado === CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO) {
      return (
        <>
          <FaRegThumbsUp /> Confirmar{' '}
        </>
      )
    }

    return (
      <>
        <FaRegThumbsUp /> Confirmado{' '}
      </>
    )
  }, []);

  return (
    <Container>
      {showModalOrcamento && (
        <Modal
          titulo="Valor Particular X Associado"
          show={showModalOrcamento}
          handleFecharModal={
            () => {
              setShowModalOrcamento(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <OrcamentoProcedimento
            exibeBusca={false}
            procedimentos={procedimentosAgendamento.map(pro => pro.ProCodigo)}
          />
        </Modal>
      )}

      {showModalCancelar && (
        <Modal
          titulo="Cancelar agendamento"
          show={showModalCancelar}
          large={false}
          className="mt-4"
          handleFecharModal={() => setShowModalCancelar(false)}
        >
          <div className="text-center">
            <FaExclamationCircle size={48} color="#dc3545" />
            <h6>
              Deseja apenas cancelar o agendamento ou adicionar na tabela de
              faltas para remarcação?
            </h6>
            <div className="d-flex justify-content-between">
              <Button
                type="button"
                variant="danger"
                size="sm"
                className="float-right ml-2"
                onClick={() => handleCancelaAgendamento(false)}
                disabled={loading}
              >
                CANCELAR
              </Button>

              <Button
                type="button"
                variant="danger"
                size="sm"
                className="float-right ml-2"
                onClick={() => handleCancelaAgendamento(true)}
                disabled={loading}
              >
                ADICIONAR FALTA
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {showModalTransferirAgenda && perfil && AgeCodigo && agendamentoDados && (
        <Modal
          show={showModalTransferirAgenda}
          titulo="Tranferir Agendamento"
          handleFecharModal={() => setShowModalTransferirAgenda(false)}
        >
          <TransferirAgendamento
            AgeCodigo={AgeCodigo}
            PerCodigo={Number(perfil)}
            duracao={agendamentoDados.duracao}
            updated_at={updatedAt}
            handleFechar={handleTransferiuAgenda}
          />
        </Modal>
      )}

      {showModalTransferirPaciente && paciente && AgeCodigo && (
        <Modal
          show={showModalTransferirPaciente}
          titulo="Tranferir Paciente"
          handleFecharModal={() => setShowModalTransferirPaciente(false)}
        >
          <TransferirPacienteAgendamento
            AgeCodigo={AgeCodigo}
            updated_at={updatedAt}
            cartao={cartaoEmDia}
            paciente={paciente}
            handleFechar={handleTransferiuAgenda}
          />
        </Modal>
      )}
      {exibeAgendamento ? (
        <>
          {paciente && pacienteID && (
            <>
              <PacienteCabecalho
                paciente={paciente}
                pacienteID={pacienteID}
                cartao={{ possuiCartao: !!dadosPlano, ...dadosPlano }}
                exibeEditar
                exibeInfoCartao
                handleAlterouDados={dados =>
                  handleVerificaDadosObrigatoriosPaciente(dados)
                }
              />
              <AgendamentosPaciente
                PacCodigo={pacienteID}
                PacNome={paciente.PacNome}
                agendamentos={agendamentosPaciente}
                atendimentos={atendimentos}
                faltas={faltas}
              />

              {pacienteDadosObrigatorios &&
                pacienteDadosObrigatorios.dadosValidos === false && (
                  <span
                    className="badge badge-pill badge-danger"
                    style={{ fontSize: '.9rem' }}
                  >
                    {pacienteDadosObrigatorios.msg}
                  </span>
                )}
            </>
          )}

          <hr className="my-1" />
          {agendamentoDados && (
            <Form
              ref={formRefAgendamento}
              initialData={{
                ...dataHoraInitialDataForm,
                duracaoTotal:
                  agendamentoDados && agendamentoDados.duracao
                    ? agendamentoDados.duracao
                    : total.duracao,
                AgeObs: agendamentoDados?.AgeObs,
                AgeGuia: agendamentoDados?.AgeGuia,
                AgeConvCodigo: agendamentoDados?.AgeConvCodigo,
              }}
              onSubmit={handleSubmitAgendamento}
            >
              {exibePermissaoAdmin && (
                <PermissaoAdmin className="shadow border">
                  <div>
                    <h6>Permissão necessária</h6>
                    <p>{mensagemPermissaoAdmin}</p>
                    <Input name="login" label="Código ou Email" />
                    <Input
                      name="senha"
                      label="Senha"
                      autoComplete="off"
                      type="password"
                    />
                    <Button
                      type="submit"
                      variant="primary mt-2"
                      size="sm"
                      disabled={loading}
                    >
                      {loading ? 'Enviando...' : 'Confirmar'}
                    </Button>

                    <Button
                      type="button"
                      variant="outline-secondary mt-2 float-right"
                      size="sm"
                      disabled={loading}
                      onClick={() => {
                        setExibePermissaoAdmin(false);
                        setMensagemPermissaoAdmin('');
                      }}
                    >
                      Voltar
                    </Button>
                  </div>
                </PermissaoAdmin>
              )}
              <Row className="mb-2" noGutters>
                <Col xs={6} md={3} sm={6}>
                  <Input
                    name="AgeData"
                    label="Data"
                    type="date"
                    onBlur={handleAlteraData}
                    disabled={ageTratamento > 0}
                  />
                </Col>
                <Col xs={6} md={2} sm={6} className="pl-1">
                  <SelectSync
                    name="AgeHora"
                    label="Hora"
                    placeholder="Selecione"
                    isClearable={false}
                    handleSelectChange={handleOnChangeVazio}
                    options={optionsHora}
                    isDisabled={ageTratamento > 0}
                  />
                </Col>
                <Col xs={6} md={4} sm={6} className="pl-1">
                  <Select
                    label="Status"
                    name="AgeStatus"
                    options={optionsStatusAgendamento}
                    disabled
                  />
                </Col>

                {(ageStatus === STATUS_AGENDA.AGENDADO ||
                  ageStatus === STATUS_AGENDA.AGENDADO + 1 ||
                  ageStatus === STATUS_AGENDA.PAGAMENTO_ANTECIPADO) &&
                  AgeCodigo &&
                  temProcedimentos && (
                    <>
                      <Col xs={3} md={2} sm={3} className="pl-1">
                        <Button
                          type="button"
                          style={{ marginTop: '18px' }}
                          size="sm"
                          variant="outline-info"
                          onClick={() =>
                            handleConfirmarAgenda(CONFIRMACAO_AGENDA.CONFIRMADO)
                          }
                          disabled={
                            (agendamentoBloqueado &&
                              ageTratamento === 0 &&
                              ageCheckup === 0 &&
                              ageStatus !==
                              STATUS_AGENDA.PAGAMENTO_ANTECIPADO) ||
                            bloqueiaDiaPassado ||
                            loading ||
                            ageConfirmado >
                            CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO
                          }
                        >
                          {IconeConfirmado(ageConfirmado)}
                        </Button>
                      </Col>
                      <Col xs={3} md={1} sm={3} className="pl-1">
                        <Button
                          type="button"
                          style={{ marginTop: '18px' }}
                          size="sm"
                          variant="outline-danger"
                          title="Desconfirmar"
                          onClick={() =>
                            handleConfirmarAgenda(
                              CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO,
                            )
                          }
                          disabled={
                            (agendamentoBloqueado &&
                              ageTratamento === 0 &&
                              ageCheckup === 0 &&
                              ageStatus !==
                              STATUS_AGENDA.PAGAMENTO_ANTECIPADO) ||
                            bloqueiaDiaPassado ||
                            loading ||
                            ageConfirmado ===
                            CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO
                          }
                        >
                          <FaRegThumbsDown />
                        </Button>
                      </Col>
                    </>
                  )}
              </Row>
              <Row className="mb-2" noGutters>
                <Col
                  md={3}
                  className={`${!clinica.CliAtendeConvenio ? 'd-none' : ''}`}
                >
                  <SelectSync
                    name="AgeConvCodigo"
                    label={
                      loadingProcedimento || loadingProcedimentosHook
                        ? 'Atualizando ...'
                        : 'Convênio'
                    }
                    placeholder="Selecione"
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                    options={optionsConvenio}
                    isDisabled={
                      agendamentoBloqueado ||
                      loadingProcedimento ||
                      loadingProcedimentosHook
                    }
                    onChange={handleOnChangeConvenio}
                  />
                </Col>
                <Col
                  md={3}
                  className={`${!clinica.CliAtendeConvenio ? 'd-none' : 'pl-2'
                    }`}
                >
                  <Input
                    name="AgeGuia"
                    label="Guia"
                    type="text"
                    disabled={ageTratamento > 0 || ageCheckup > 0}
                  />
                </Col>
              </Row>
              {ageCheckup > 0 && (
                <p className="mb-2">
                  <Link
                    to={`/AgendaCheckup/edit/${ageCheckup}/1`}
                    target="_blank"
                  >
                    PACOTE / CHECKUP
                  </Link>
                </p>
              )}
              <TextArea name="AgeObs" label="Observação" rows={3} />
              <Row className="mt-2">
                <Col xs={12} md={7}>
                  <SelectSync
                    name="procedimento"
                    label="Procedimento"
                    placeholder="Selecione"
                    handleSelectChange={handleProcedimentoChange}
                    options={optionsProcedimentos}
                  />
                </Col>
                <Col xs={5} md={2}>
                  <InputFake
                    label="Duração"
                    disabled
                    value={
                      procedimentoSelecionado
                        ? procedimentoSelecionado?.ProDuracao
                        : ''
                    }
                  />
                </Col>
                <Col xs={5} md={2}>
                  <InputFake
                    label="Valor"
                    disabled
                    value={
                      agePlano && cartaoEmDia
                        ? procedimentoSelecionado?.ProValorPlano
                        : procedimentoSelecionado?.ProValor
                    }
                  />
                </Col>
                <Col xs={2} md={1}>
                  <Button
                    type="button"
                    style={{ marginTop: '18px' }}
                    size="sm"
                    variant="outline-info"
                    onClick={() => handleAddProcedimento()}
                    disabled={agendamentoBloqueado || loadingProcedimento}
                  >
                    {loadingProcedimento ? (
                      <Spinner>
                        <FaSpinner />
                      </Spinner>
                    ) : (
                      <FaPlusCircle />
                    )}
                  </Button>
                </Col>
              </Row>

              {procedimentosAgendamento && procedimentosAgendamento.length > 0 && (
                <>
                  <Row className="mt-2">
                    <Col xs={8} md={9}>
                      Procedimentos selecionados, Total{' '}
                      {procedimentosAgendamento.length}
                    </Col>
                    <Col xs={2} md={2}>
                      Valor
                    </Col>
                    <Col xs={2} md={1} />
                  </Row>

                  {procedimentosAgendamento.map(proced => (
                    <Row
                      className="align-items-center border-bottom p-1"
                      key={`pro-${proced.ProCodigo.toString()}`}
                    >
                      <Col xs={8} md={9}>
                        {proced.ProNome}
                      </Col>
                      <Col xs={2} md={2}>
                        {proced.ProValorFormatado}
                      </Col>
                      <Col xs={2} md={1}>
                        {!agendamentoBloqueado && (
                          <Button
                            type="button"
                            variant="outline-danger"
                            size="sm"
                            className="py-0"
                            onClick={() => {
                              handleRemoveProcedimento(proced.ProCodigo);
                            }}
                          >
                            <FaTrashAlt />
                          </Button>
                        )}
                      </Col>
                    </Row>
                  ))}
                  <Row className="mt-2">
                    <Col xs={6} md={3} lg={2}>
                      <InputFake
                        label="Valor Total"
                        disabled
                        value={total.valorFormatado}
                      />
                    </Col>
                    <Col xs={6} md={3} lg={2}>
                      <Input
                        label="Duração Total"
                        name="duracaoTotal"
                        type="number"
                        min="5"
                        max="120"
                        step="5"
                      />
                    </Col>
                  </Row>
                </>
              )}
              <br />
              {valorEconomizado && (
                <div className="alert alert-info d-block mb-1">
                  <GiPartyPopper size={15} /> Parabéns, você economizou{' '}
                  <b>{valorEconomizado}</b> por ser nosso associado
                </div>
              )}
              {temProcedimentos && !agendamentoBloqueado && (
                <Button
                  type="submit"
                  className="mr-2"
                  size="sm"
                  disabled={
                    agendamentoBloqueado || bloqueiaDiaPassado || loading
                  }
                >
                  Salvar
                </Button>
              )}
              {temProcedimentos && ageStatus === STATUS_AGENDA.FALTA && (
                <Button
                  type="button"
                  className="mr-2"
                  size="sm"
                  variant="outline-success"
                  onClick={() =>
                    setAgeConfirmado(CONFIRMACAO_AGENDA.CONFIRMADO)
                  }
                >
                  Reagendar
                </Button>
              )}

              {(ageStatus === CONFIRMACAO_AGENDA.CONFIRMADO ||
                ageStatus === CONFIRMACAO_AGENDA.CONFIRMADO + 1) &&
                temProcedimentos && (
                  <Button
                    type="button"
                    variant="success"
                    size="sm"
                    onClick={() =>
                      handleSubmitMudaStatus(STATUS_AGENDA.ENCAMINHADO_CAIXA)
                    }
                    disabled={
                      (agendamentoBloqueado &&
                        ageTratamento === 0 &&
                        ageCheckup === 0) ||
                      bloqueiaDiaPassado ||
                      bloqueiaDadosInclompletos ||
                      loading
                    }
                  >
                    Encaminhar Caixa
                  </Button>
                )}
              {ageStatus === STATUS_AGENDA.PAGAMENTO_ANTECIPADO && (
                <>
                  <Button
                    type="button"
                    className="ml-2"
                    size="sm"
                    disabled={bloqueiaDadosInclompletos || loading}
                    onClick={handleEncaminhaAntecipado}
                  >
                    Encaminhar para atendimento
                  </Button>
                  <Button
                    type="submit"
                    className="ml-2"
                    size="sm"
                    disabled={loading}
                  >
                    Alterar Data
                  </Button>
                  <Button
                    type="button"
                    className="ml-2"
                    variant="success"
                    size="sm"
                    disabled={loading}
                    onClick={handleSalvarObservacao}
                  >
                    Salvar Observação
                  </Button>
                  {user.UsuCodigo === 1 && (
                    <>
                      <Button
                        type="button"
                        className="ml-2"
                        variant="success"
                        size="sm"
                        disabled={loading}
                        onClick={() => setShowModalTransferirAgenda(true)}
                      >
                        Transferir Agenda
                      </Button>

                      <Button
                        type="button"
                        className="ml-2"
                        variant="success"
                        size="sm"
                        disabled={loading}
                        onClick={() => setShowModalTransferirPaciente(true)}
                      >
                        Transferir Paciente
                      </Button>
                    </>
                  )}
                </>
              )}

              {exibePedidoExame && perfilNome !== 'CHECKUP' && (
                <Link
                  className="btn btn-sm btn-outline-secondary float-right ml-2"
                  to={`/impressaodocumento/${AgeCodigo}/pedidoexame`}
                  target="_blank"
                >
                  <FaPrint /> Pedido Exame
                </Link>
              )}

              {(ageStatus === CONFIRMACAO_AGENDA.CONFIRMADO ||
                ageStatus === CONFIRMACAO_AGENDA.CONFIRMADO + 1) &&
                !agePlano &&
                temProcedimentos && (
                  <Button
                    type="button"
                    variant="outline-primary"
                    size="sm"
                    className="float-right ml-2"
                    onClick={() => setShowModalOrcamento(true)}
                    disabled={
                      agendamentoBloqueado || bloqueiaDiaPassado || loading
                    }
                  >
                    Valor Associado
                  </Button>
                )}

              {AgeCodigo && AgeCodigo !== 0 && (
                <Button
                  type="button"
                  variant="outline-primary"
                  size="sm"
                  className="float-right ml-2"
                  onClick={() => handleExibeHistorico(showHistorico)}
                >
                  Histórico
                </Button>
              )}

              {AgeCodigo && AgeCodigo !== 0 && !agendamentoBloqueado && (
                <Button
                  type="button"
                  variant="danger"
                  size="sm"
                  className="float-right ml-2"
                  onClick={() => setShowModalCancelar(true)}
                  disabled={loading}
                >
                  Cancelar
                </Button>
              )}
            </Form>
          )}
          {showHistorico && historico && historico.length > 0 && (
            <>
              <Row className="mt-2 bg-light py-1 border-bottom">
                <Col md={2}>
                  <b>Data</b>
                </Col>
                <Col xl={9} md={9}>
                  <b>Histórico</b>
                </Col>
              </Row>

              {historico.map(his => (
                <Row
                  className="align-items-center border-bottom p-1"
                  key={`his-${his.HisCodigo.toString()}`}
                >
                  <Col xl={2} md={2}>
                    {his.HisDataFormatada}
                  </Col>
                  <Col xl={9} md={9}>
                    <span dangerouslySetInnerHTML={{ __html: his.HisLog }} />
                  </Col>
                </Row>
              ))}
            </>
          )}
        </>
      ) : (
        <>
          {loading && <Loading backgroundBlack={false} />}
          <BuscaPaciente
            loading={loading}
            handleSelectCliente={handleSelectClienteChange}
          />
        </>
      )}
      <Row className="align-items-center p-1">
        <Col md="12">
          <Container
            className={`light-grey text-left pt-3 ${agendamentoDados &&
              agendamentoDados.AgeChave &&
              ageStatus === STATUS_AGENDA.ENCAMINHADO_CAIXA &&
              clinica.ConfigBoleto?.EmiteOnLine &&
              process.env.REACT_APP_URL_SITE
              ? ''
              : 'd-none'
              }`}
          >
            <CopiarAreaTrabalho
              texto={`${process.env.REACT_APP_URL_SITE}/agendamento/pagamento/${agendamentoDados?.AgeChave}?less=login`}
            />
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default Agendamento;
